import React, { useRef } from "react";
import { EllipsisVertical } from "lucide-react";

import { useRunAfterMenuClose } from "../Modal/dialogHelpers";
import { Button } from "../../shadcn/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../shadcn/components/ui/dropdown-menu";

// Row actions. The page owns open/anchorEl (often one state for every row),
// so a menu only opens when its own button is the anchor.
// Pages' close handlers may call event.stopPropagation(); always pass an event.
const NO_EVENT = { stopPropagation() {}, preventDefault() {} };

const TableActionsMenu = ({
  actions,
  handleClickAction,
  handleCloseActionMenu,
  rowData,
  open,
  anchorEl,
}) => {
  const triggerRef = useRef(null);
  const { runAfterClose, onOpenChangeComplete } = useRunAfterMenuClose();
  const isOpen =
    Boolean(open) && (!anchorEl || anchorEl === triggerRef.current);

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChangeComplete={onOpenChangeComplete}
      onOpenChange={(nextOpen, eventDetails) => {
        if (!nextOpen) handleCloseActionMenu?.(eventDetails?.event || NO_EVENT);
      }}
    >
      <DropdownMenuTrigger
        ref={triggerRef}
        onClick={(event) => {
          // Rows open details on click; the trigger never activates its row.
          event.stopPropagation();
          // The trigger itself closes an open menu; do not reopen it.
          if (!isOpen) handleClickAction(event, rowData);
        }}
        render={<Button type="button" variant="ghost" size="icon-sm" />}
      >
        <EllipsisVertical aria-hidden="true" />
      </DropdownMenuTrigger>
      {/* Menu clicks must not reach the table row (rows open details on click). */}
      <DropdownMenuContent
        align="end"
        className="w-auto min-w-48"
        onClick={(event) => event.stopPropagation()}
      >
        {actions.map((action) => (
          <DropdownMenuItem
            key={action.label}
            disabled={Boolean(action.disabled)}
            onClick={(event) => {
              if (action.disabled) return;
              handleCloseActionMenu?.(event || NO_EVENT);
              runAfterClose(() => action.onClickAction(rowData, event));
            }}
          >
            {action.icon}
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TableActionsMenu;
